export default __webpack_public_path__ + "static/media/Clínica-São-Leopoldo.9bcf0e77.png";